import request from './HttpService';
import { ENDPOINTS, GLOBAL_USER } from '../utils/constants';

export interface IBulkUpdateUploadData {
  bucket: string;
  key: string;
  size: number;
  dataRowsCount: number;
  updateRowsCount: number;
  updateBatchCount: number;
  matchedCount: number;
  modifiedCount: number;
}

export interface IBulkUpdateUploadResponse {
  statusCode: number;
  message: string;
  data: IBulkUpdateUploadData;
}

// Generous because the backend parses and applies every row before responding.
export const BULK_UPDATE_UPLOAD_TIMEOUT_MS = 120000;

export const uploadBulkUpdateFile = async (file: File, signal?: AbortSignal): Promise<IBulkUpdateUploadResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('requestor', GLOBAL_USER);

  // Content-Type is intentionally omitted so axios sets the multipart boundary.
  const { data } = await request.post<IBulkUpdateUploadResponse>(ENDPOINTS.uploadVehicleExcel, formData, {
    timeout: BULK_UPDATE_UPLOAD_TIMEOUT_MS,
    signal,
  });
  return data;
};
